/**
 * The department role recipes Chief can build a lead from. The recipes themselves (duties,
 * routines, how-tos and approval defaults) live in core; only their ids are part of the contract.
 */
export const ROLE_RECIPE_IDS = [
  "support",
  "finance",
  "executive_assistant",
  "operations",
  "sales",
  "marketing",
  "website",
] as const;
export type RoleRecipeId = (typeof ROLE_RECIPE_IDS)[number];
